export function formatFiltersLegend(baseLabel: string, activeCount: number): string {
  if (activeCount <= 0) {
    return baseLabel
  }
  return `${baseLabel} (${activeCount})`
}

export function countActive(...checks: boolean[]): number {
  return checks.filter(Boolean).length
}

export function isNonEmptyText(value?: string | null): boolean {
  return (value?.trim().length ?? 0) > 0
}

export function isNonEmptyArray<T>(value?: T[] | null): boolean {
  return (value?.length ?? 0) > 0
}

export function isSetValue<T>(value: T | null | undefined): boolean {
  return value !== null && value !== undefined
}
